import React from 'react';
import './RankingFilter.css';

const RankingFilter = (props) =>{
  let setRankingCategory = props.setRankingCategory;
  let categories = [];
  switch(props.period){
    case 'current':
      categories = props.thisMonthCategories;
      break;
    case 'previous':
      categories = props.previousMonthCategories;
      break;
    case 'total':
      categories = props.categories;
      break;
    default:
      categories = props.thisMonthCategories;
      break;
  }

  return (
    <div className="RankingFilter">
      <select value={props.rankingCategory} onChange={(e) => {setRankingCategory(e.target.value); } } >
        <option value="All" data-type="0" >All disciplines</option>
        {categories && categories.map( (i) =>
          <option key={i.name} value={i.name} data-type={i.type} >
            {i.displayName}
          </option>
        )}
      </select>
    </div>
  )
}

export default RankingFilter;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/RankingFilter/RankingFilter.js